import { useEffect } from "react";
import { BusinessAreaService } from "../../../services/BusinessAreaService";
import BusinessAreaSearch from "./BusinessAreaSearch";
import { useState } from "react";
import BusinessAreaCreateOrEdit from "./BusinessAreaCreateOrEdit";
import BusinessAreaList from "./BusinessAreaList";
import { func } from "prop-types";
import BusinessAreaDelete from "./BusinessAreaDelete";
import { get } from "http";
import Pagination from "../../../components/Pagination";
export default function BusinessAreaListPage() {
  const [searchObject, setSearchObject] = useState({});
  const [businessAreas, setBusinessAreas] = useState([]);
  const [businessAreaId, setBusinessAreaId] = useState();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [businessAreaForDelete, setBusinessAreaForDelete] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isOpenCreatOrEdit, setIsOPenCreatOrEdit] = useState(false);
  const pageSize = 20;
  useEffect(() => {
    getBusinessAreas();
  }, [searchObject, pageNumber]);

  function getBusinessAreas() {
    BusinessAreaService.getBusinessAreas(
      pageSize,
      pageNumber,
      searchObject
    ).then((data) => {
      setBusinessAreas(data.page);
      setTotalPages(data.total / pageSize);
    });
  }

  function onChangeSearch({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  function onClose() {
    setIsOPenCreatOrEdit(false);
    getBusinessAreas(pageSize, pageNumber, searchObject);
    setBusinessAreaId(null);
  }

  function setCreateOrEdit(id) {
    setIsOPenCreatOrEdit(true);
    setBusinessAreaId(id);
  }

  function setForDelete(businessArea) {
    setBusinessAreaForDelete(businessArea);
    setIsDeleteOpen(true);
  }

  function closeDelete() {
    getBusinessAreas(pageSize, pageNumber, searchObject);
    setBusinessAreaForDelete(null);
    setIsDeleteOpen(false);
  }
  return (
    <>
      <div>
        <div className="row">
          <div className="col-sm">
            <BusinessAreaSearch
              onChange={onChangeSearch}
              searchObject={searchObject}
            />
          </div>

          <div className="col-sm text-end">
            <div>
              <button
                className="app-button btn-prime btn-md"
                onClick={() => setIsOPenCreatOrEdit(true)}
              >
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>
        </div>
        <BusinessAreaList
          list={businessAreas}
          setCreateOrEdit={setCreateOrEdit}
          setSearchObject={setSearchObject}
          searchObject={searchObject}
          setForDelete={setForDelete}
        />
        <Pagination
          totalPages={totalPages}
          setPageNumber={setPageNumber}
          pageNumber={pageNumber}
        />
      </div>
      <BusinessAreaCreateOrEdit
        onClose={onClose}
        isOpen={isOpenCreatOrEdit}
        businessAreaId={businessAreaId}
      />
      <BusinessAreaDelete
        onClose={closeDelete}
        isOpen={isDeleteOpen}
        businessArea={businessAreaForDelete}
      />
    </>
  );
}
